export default (callback: EventListener): void => {
  if (document.readyState !== 'loading') {
    return callback(new Event('DOMContentLoaded'));
  }
  document.addEventListener('DOMContentLoaded', callback);
};
